import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';

export const StyledUploadExcelPopUp = styled(StyledModal)`
    color: #373647;
    font-family: var(--bllink-font-primary);

    .modal-header {
        display: flex;
        padding: 15px 20px;
        border: none;
        justify-content: flex-end !important; 

        button {
            flex: 0 0 16px;
            width: 16px;
            height: 16px;
            border: none;
            line-height: 0;
            background-color: transparent;
            cursor: pointer;
            padding: 0;
            color: var(--bllink-gray);
        }
    }

    .modal-dialog {
        .modal-body {
            padding-top: 0;

            .title {
                font-weight: 700;
                font-size: 24px;
                line-height: 28px;
                margin-bottom: 18px;
            }

            .info {
                font-size: 16px;
                line-height: 22px;
                opacity: 0.7;
            }

            .info.bottom-block {
                margin: 30px 0 54px;
            }
        }
    }

`
